import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { TransactionItem } from "../../financial.types";
import { requestTransactionById } from "./transactionById.request";

const useTransactionById = (
  id?: string | null,
  options?: QueryOptions<TransactionItem, ApiServiceError<ApiError>>
) => {
  const { data: transaction, ...rest } = useQuery({
    queryKey: ["transactions", id],
    queryFn: async () => await requestTransactionById(String(id)),
    enabled: !!id,
    ...options
  });

  return { transaction, ...rest };
};

export default useTransactionById;
